export default {
  apiKey: "AIzaSyBE2Z6t3XEmuGQctfA-RTAkPXvHEtRRP8M",
  authDomain: "endless-auth.firebaseapp.com",
  databaseURL: "https://endless-auth.firebaseio.com",
  projectId: "endless-auth",
  storageBucket: "endless-auth.appspot.com",
  messagingSenderId: "98214219540",
  appId: "1:98214219540:web:814c9568dbbc36d84cfc01"
};
